import { BrandFontTypes } from 'reservations/brand/constants/enums';
import { BrandFont } from 'reservations/brand/types/brand';

export const FONT_NAMES = {
  reg: 'Circular',
  italic: 'CircularItalic',
  bold: 'CircularBold',
  med: 'CircularMed'
};

export const customGoogleFonts: BrandFont[] = [
  // inter font
  {
    name: 'Inter',
    slug: 'inter',
    sources: [],
    variants: [
      {
        name: 'regular',
        style: 'normal',
        weight: null,
        displayName: '400 Regular'
      },
      {
        name: '500',
        style: null,
        weight: 500,
        displayName: '500 Medium'
      },
      {
        name: '900',
        style: null,
        weight: 900,
        displayName: '900 Black'
      },
      {
        name: '800',
        style: null,
        weight: 800,
        displayName: '800 ExtraBold'
      },
      {
        name: '700',
        style: null,
        weight: 700,
        displayName: '700 Bold'
      }
    ],
    isDefault: false,
    fontType: BrandFontTypes.GOOGLE
  }
];
